import { Bar } from 'vue-chartjs'
export default{
    props:['chartdata','options'],
    extends: Bar,
    watch: {
        chartdata(){
            this.renderChart(this.chartdata, this.options)
        }
    }
}